import moment from "moment";
import React from "react";
import { css } from "styled-components";
import { colors } from "sweet-web/lib/styles";
import Filter from "./Filter";

export default props => (
  <React.Fragment>
    <Filter
      width={110}
      name="date"
      title="Date"
      type="date"
      display={value => moment(value).format("ddd MMM D")}
      label={value => moment(value).format("ddd MMM D")}
      normalize={value => (value ? moment(value).format("YYYY-MM-DD") : null)}
      placeholder="Select"
      {...props}
    />
    <style>
      {css`
        .SingleDatePickerInput_clearDate:hover,
        .SingleDatePickerInput_clearDate:focus {
          background: none;
          outline: none;
        }
        .SingleDatePickerInput {
          background: none;
          border: none;
          position: relative;
        }
        .DateInput {
          background: none;
        }
        .DateInput_input {
          border: none;
        }
        #discover-filter-date-picker {
          background: none;
          color: ${colors.primary};
          font-size: 14px;
          text-align: left;
          font-weight: 600;
          margin-left: 8px;
        }
        #discover-filter-date-picker::placeholder {
          color: ${colors.primary};
        }

        .CalendarDay:hover {
          background: ${colors.lighterGray};
        }
        .CalendarDay__selected,
        .CalendarDay__selected:hover {
          background: ${colors.primary};
          border: none;
        }
        .SingleDatePickerInput_clearDate_svg {
          fill: ${colors.gray};
          margin-bottom: 3px;
          margin-left: 3px;
        }
      `}
    </style>
  </React.Fragment>
);
